module.exports = __webpack_public_path__ + "static/img/artist-rob-banner@2x.ddec0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-rob-banner@2x.png
// module id = lpCg
// module chunks = 12